module.exports = require("cbor-x");